import React from "react";
import { SITE } from "../../config/site";

export default function LocalBusinessJsonLD(){
  const data = {
    "@context":"https://schema.org",
    "@type":"LocalBusiness",
    name: SITE.brand,
    url: SITE.domain,
    telephone: SITE.phone,
    image: [`${SITE.domain}/og.jpg`],
    address: {
      "@type":"PostalAddress",
      streetAddress: SITE.address.street,
      addressLocality: SITE.address.city,
      addressRegion: SITE.address.region,
      postalCode: SITE.address.postalCode,
      addressCountry: SITE.address.country
    },
    sameAs: Object.values(SITE.socials).filter(Boolean)
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(data)}} />;
}
